module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/4@2x_d2e6f3b3886e9b454f49e8a4a8e845a8.png";